import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Departamento } from './departamentos.model';

@Injectable({
  providedIn: 'root'
})
export class DepartamentosService {
  url: string;
  constructor(private http: HttpClient) {}
  getDepartamentos(): Observable<Departamento[]> {
    return this.http.get<Departamento[]>(`${this.url}/departamentos/`);
  }
}
